import { FC } from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';
import { css } from '@linaria/core';
export const TooltipWrapper: FC<{
  toolTipText: string | JSX.Element;
  side?: 'top' | 'right' | 'bottom' | 'left';
}> = ({
  children,
  toolTipText,
  side
}) => {
  return <Tooltip.Provider>
      <Tooltip.Root delayDuration={0}>
        <Tooltip.Trigger>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content side={side} className={TooltipContentStyle}>
            {toolTipText}
            <Tooltip.Arrow />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>;
};
const TooltipContentStyle = "odules__Playground__Components__TooltipWrapper_tsx-TooltipContentStyle-t5n2d1m";

require("./TooltipWrapper.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./TooltipWrapper.tsx");